import React from 'react';
import { Menu, Button } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { downloadExport } from '../../hooks/useImportExportApi';

interface ExportButtonProps {
  url: string;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ url }) => {
  const { t } = useTranslation();

  return (
    <Menu shadow="md" width={160}>
      <Menu.Target>
        <Button variant="light" leftSection={<IconDownload size={16} />}>
          {t('importExport.export')}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={() => downloadExport(url, 'csv')}>{t('importExport.csv')}</Menu.Item>
        <Menu.Item onClick={() => downloadExport(url, 'xlsx')}>{t('importExport.excel')}</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
